<main>
    <div>
        <app-sidenav></app-sidenav>
        <div>
            <app-header></app-header>
            <router-outlet></router-outlet>
        </div>
    </div>
</main>